import styled from "styled-components";
import { FlexContainer } from "../../../styles/sharedStyles";
import { getTypography } from "styles/designTokens";

export const NavContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 65px;
  background: white;
  border-bottom: 1px #e5e8eb solid;
  z-index: 1000;
`;

export const NavInner = styled(FlexContainer)`
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;
  justify-content: space-between;
`;

export const LogoSection = styled(FlexContainer)``;

export const Button = styled.button`
  ${getTypography("korean", "body2")}
  font-weight: 600;
  padding: 0 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    font-weight: 600;
    color: #5c6eff;
  }
`;

export const RightSection = styled(FlexContainer)`
  gap: 36px;
`;

export const LoginButton = styled(Button)`
  background: transparent;
  border: none;
  padding: 0;
`;

export const ContactButton = styled(Button)`
  background: transparent;
  border: none;
  padding: 0;
`;
